import { useEffect, useState } from "react"
import "./FiltrosGerenciaPermissoes.css"
import { get } from "../../services/api"
import Select from 'react-select'

function FiltrosGerenciaPermissoes({ setPermissoes }) {
    const [ setores, setSetores ] = useState([])
    const [ tipos, setTipos ] = useState([])
    const [codigoValue, setCodigoValue] = useState('')
    const [nomeValue, setNomeValue] = useState('')
    const [organizacaoValue, setOrganizacaoValue] = useState({ value: '', label: 'Selecione' })
    const [setorValue, setSetorValue] = useState({ value: '', label: 'Selecione' })
    const [papelValue, setPapelValue] = useState({ value: '', label: 'Selecione' })

    const selectStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '38px',
            height: '38px',
            display: 'flex',
            alignItems: 'center',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '38px',
            padding: '0 8px',
            display: 'flex',
            alignItems: 'center',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '0.8rem',
            margin: 0,
            lineHeight: '38px',
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '0.8rem',
            margin: 0,
            lineHeight: '38px',
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            lineHeight: '38px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '38px',
        }),
    }

    async function setSetoresWithRequest(authToken) {
        try {
            const setores = await get('/admin/setores', null, authToken)
            setSetores(setores)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setTiposWithRequest(authToken) {
        try {
            const tipos = await get('/admin/permissoes/tipos', null, authToken)
            setTipos(tipos)
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken != null) {
            setSetoresWithRequest(authToken)
            setTiposWithRequest(authToken)
        }
    }, [])

    function parseObjectToURLQuery(object) {
        return Object.keys(object).reduce(
            (accumulator, paramKey) => {
                if(object[paramKey])
                    return accumulator + `&${paramKey}=${object[paramKey]}`
                else return accumulator
            }, '')
    }

    function handleSubmit(event){
        event.preventDefault()
        

        const formJson = {
            codigo: codigoValue,
            nome: nomeValue,
            origem: organizacaoValue?.value || '',
            setor: setorValue?.value || '',
            tipo: papelValue?.value || ''
        }
        
        const queryParams = parseObjectToURLQuery(formJson)
        setPermissoes(queryParams)
    }

    const organizacaoOptions = [
        { value: '', label: 'Selecione' },
        { value: 1, label: 'Departamento' },
        { value: 2, label: 'Individual' }
    ]

    return (
        <form onSubmit={handleSubmit} className='filtros-permissoes-wrapper'>
            <div className='header'>
                <span>2</span>
                <h1>Consultar Acessos</h1>
            </div>
            <div className='body'>
                <div className="codigo-wrapper">
                    <label htmlFor="codigo">Código</label>
                    <input 
                        type="text" 
                        name="codigo" 
                        className="codigo"
                        value={codigoValue}
                        onChange={(e) => setCodigoValue(e.target.value)}
                    />
                </div>

                <div className="codigo-wrapper">
                    <label htmlFor="organizacao">Organização</label>
                    <Select
                        name="organizacao"
                        className="organizacao"
                        options={organizacaoOptions}
                        value={organizacaoValue}
                        onChange={setOrganizacaoValue}
                        styles={selectStyles}
                    />
                </div>

                <div className="codigo-wrapper">
                    <label htmlFor="nome">Nome</label>
                    <input 
                        type="text" 
                        name="nome" 
                        className="nome"
                        value={nomeValue}
                        onChange={(e) => setNomeValue(e.target.value)}
                    /> 
                </div>

                <div className="codigo-wrapper">
                    <label htmlFor="setor">Setor</label>
                    <Select
                        name="setor"
                        className="setor"
                        options={setores && setores.length > 0 ? 
                            [
                                { value: '', label: 'Selecione' },
                                ...setores.map(setor => ({
                                    value: setor.id_departamento, 
                                    label: setor.departamento 
                                }))
                            ] : 
                            [{ value: '', label: 'Selecione' }]
                        }
                        value={setorValue}
                        onChange={setSetorValue}
                        styles={selectStyles}
                    />
                </div>

                <div className="codigo-wrapper">
                    <label htmlFor="papel">Papel</label>
                    <Select
                        name="papel"
                        className="papel"
                        options={tipos && tipos.length > 0 ? 
                            [
                                { value: '', label: 'Selecione' },
                                ...tipos.map(tipo => ({ 
                                    value: tipo.id_tipo, 
                                    label: tipo.descricao 
                                }))
                            ] : 
                            [{ value: '', label: 'Selecione' }]
                        }
                        value={papelValue}
                        onChange={setPapelValue}
                        styles={selectStyles}
                    />
                </div>

                <button className="btn-filtrar-permissoes" type="submit">Filtrar</button>      
            </div>
        </form>
    )
}

export default FiltrosGerenciaPermissoes